import React, { useState } from 'react';
import "../Signup/Signup.scss";
import bgBanner from "../../assets/images/bg-img.svg";
import LogoIcon from "../../assets/images/white_locshark_1.png";
import { Formik } from 'formik';
import * as Yup from "yup";
import { USER_MANAGEMENT } from '../../utils/const';
import useApi from '../../hook/useAPI';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const initialValues = {
    email: email
  }
  const { postData, getData } = useApi();
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(emailRegex, "Invalid email format")
      .required("Email is required")
  });
  const navigate = useNavigate();

  const handleForgotPassword = async (data) => {
    try {
      const { email } = data;
      if (!email) {
          setError('Email not found');
      }
      const response = await postData(USER_MANAGEMENT.RESET_PASSWORD_EMAIL, { email: email });
      if (response && response.status && response.status == 200) {
        toast.success(response?.message);
        setTimeout(() => {
          navigate('/');
        }, 2000);
      } else {
        toast.error(response?.message);
      }

    } catch (error) {
      console.log("error ", error);
    }
  }
  return (
    <div className="login-section signup-page forgot-password-page">
      <div className="container m-0">
        <div className="row m-0">
          <div className="col-md-4 p-0">
            <div className="sign-bg-banner ">
              <img src={bgBanner} className="img-fluid " alt="signup-background" />
              <div className="over-sml-img">
                <img src={LogoIcon} className="img-fluid" alt="signup-logo" />
              </div>
            </div>
          </div>
          <div className="col-md-8 d-flex align-items-center justify-content-center px-0 px-sm-0 px-md-4">
            <div className='create-ac-main-box'>
              <h4 className='mt-4'>Forgot Password</h4>
              <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={validationSchema}
                onSubmit={(formData) => handleForgotPassword(formData)}
              >
                {({
                  values,
                  touched,
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit} noValidate>
                    <div className='create-account-box'>
                      <div className='row'>
                        <div className='col-md-12'>
                          <div className="form_field_wrapper ">
                            <label>Email</label>
                            <input
                              value={values.email}
                              type="text"
                              name="email"
                              className="form-control"
                              placeholder="Enter your Email"
                              onChange={(e) => {
                                setError("");
                                handleChange(e);
                              }}
                              onBlur={handleBlur}
                            />
                            {errors.email && touched.email && (
                              <div className="error-message">{errors.email}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className='create-account-btn'>
                        <button type="submit">Submit</button>
                      </div>
                      {error && <span style={{"color": "red"}}>{error}</span>}
                    </div>
                  </form>
                )}
              </Formik>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword